export const core = {
    common: {
        save: 'Simpan',
        cancel: 'Batal',
        delete: 'Hapus',
        edit: 'Edit',
        add: 'Tambah',
        search: 'Cari',
        loading: 'Memuat...',
        success: 'Berhasil',
        error: 'Error',
        confirm: 'Konfirmasi',
        close: 'Tutup',
        view: 'Lihat',
        back: 'Kembali',
        next: 'Lanjut',
        previous: 'Sebelumnya',
        submit: 'Kirim',
        refresh: 'Refresh',
        filter: 'Filter',
        export: 'Export',
        import: 'Import',
        download: 'Download',
        upload: 'Upload',
        actions: 'Aksi',
        status: 'Status',
        date: 'Tanggal',
        total: 'Total',
        subtotal: 'Subtotal',
        name: 'Nama',
        email: 'Email',
        phone: 'Telepon',
        address: 'Alamat',
        description: 'Deskripsi',
        notes: 'Catatan',
        settings: 'Pengaturan',
        logout: 'Keluar',
        login: 'Masuk',
        register: 'Daftar',
        yes: 'Ya',
        no: 'Tidak',
        all: 'Semua',
        active: 'Aktif',
        inactive: 'Tidak Aktif',
    },
    sidebar: {
        dashboard: 'Dashboard',
        orders: 'Pesanan',
        customers: 'Pelanggan',
        forms: 'Formulir',
        abandonedCarts: 'Keranjang Ditinggalkan',
        adReports: 'Laporan Iklan',
        csReports: 'Laporan CS',
        cuanRank: 'Cuan Rank',
        settings: 'Pengaturan',
        myProfile: 'Profil Saya',
        earnings: 'Pendapatan',
    },
    header: {
        notifications: 'Notifikasi',
        profile: 'Profil',
        darkMode: 'Mode Gelap',
        lightMode: 'Mode Terang',
        language: 'Bahasa',
    },
    dashboard: {
        title: 'Dashboard',
        totalRevenue: 'Total Pendapatan',
        totalOrders: 'Total Pesanan',
        totalCustomers: 'Total Pelanggan',
        conversionRate: 'Tingkat Konversi',
        recentOrders: 'Pesanan Terbaru',
        topProducts: 'Produk Terlaris',
        revenueChart: 'Grafik Pendapatan',
        ordersChart: 'Grafik Pesanan',
        viewAll: 'Lihat Semua',
    },
};
